import React, { useContext } from 'react';

const Context = React.createContext({
  game: null,
  setGame: () => {},
});

const Provider = props => (
  <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

const useGameContext = () => useContext(Context);

export { Context, Provider, useGameContext };
